import { TimetableAdminSettings } from "@features/portal-administration/components/TimetableAdminSettings";
import { hasPermission } from "@features/rbac/permissions";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/admin/timetables")({
	beforeLoad: () => {
		if (!hasPermission("timetables.manage")) {
			throw redirect({ to: "/unauthorised" });
		}
	},
	component: TimetableAdminSettings,
});
